module.exports = __webpack_public_path__ + "static/snowflake-d060585775b9114e370be229bdb0d974.png";